import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobViewModel from '../../JobViewModel'
import JobProgressionViewModel from '../JobProgressionViewModel'
import styles from './ReturnFiled.sass'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface ReturnFiledProgressionProps {
  vm: JobProgressionViewModel
  jobVM: JobViewModel
  canCompleteJob?: boolean
}

export default observer(function ReturnFiledProgressionActions({
  vm,
  jobVM,
  canCompleteJob,
}: ReturnFiledProgressionProps) {
  return (
    <>
      {!vm.isAnyExtensionFlowAvailable && (
        <CardContent compactBottomPadding={vm.isAnyExtensionFlowAvailable}>
          <Button
            type="primary"
            size="wide-slim"
            onClick={() => vm.closeJob()}
            dataTest="job-progression-complete-job-button"
            disabled={!canCompleteJob}
          >
            Complete Job
          </Button>
          {!canCompleteJob && (
            <div className={styles.pendingActions}>
              {jobVM.pendingActionsText}
            </div>
          )}
        </CardContent>
      )}

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} />
      )}
    </>
  )
})
